import { QueryKey } from '@tanstack/query-core';

export default function convertQueryKeyToUrl(queryKey: QueryKey) {
  return queryKey.join('/').replace('/?', '?');
}
